/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './accounting-transaction-bill.reducer';

export const AccountingTransactionBillDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const accountingTransactionBillEntity = useAppSelector(state => state.accountingTransactionBill.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="accountingTransactionBillDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.detail.title">AccountingTransactionBill</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.id">Id</Translate>
            </span>
          </dt>
          <dd>{accountingTransactionBillEntity.id}</dd>
          <dt>
            <span id="billId">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.billId">Bill Id</Translate>
            </span>
            <UncontrolledTooltip target="billId">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.billId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionBillEntity.billId}</dd>
          <dt>
            <span id="billCategory">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.billCategory">Bill Category</Translate>
            </span>
            <UncontrolledTooltip target="billCategory">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.billCategory" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionBillEntity.billCategory}</dd>
          <dt>
            <span id="paymentId">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.paymentId">Payment Id</Translate>
            </span>
            <UncontrolledTooltip target="paymentId">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.paymentId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionBillEntity.paymentId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionBillEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionBillEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionBillEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionBillEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionBillEntity.timestampEntry}</dd>
          <dt>
            <span id="accountingTransactionId">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.accountingTransactionId">
                Accounting Transaction Id
              </Translate>
            </span>
            <UncontrolledTooltip target="accountingTransactionId">
              <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.accountingTransactionId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionBillEntity.accountingTransactionId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.collection">Collection</Translate>
          </dt>
          <dd>{accountingTransactionBillEntity.collection ? accountingTransactionBillEntity.collection.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/accounting-transaction-bill" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/accounting-transaction-bill/${accountingTransactionBillEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AccountingTransactionBillDetail;
